import {
  VERFY_LOGIN_OTP_REQUEST,
  VERFY_LOGIN_OTP_SUCCESS,
  VERFY_LOGIN_OTP_FAILURE,
  VERFY_LOGIN_OTP_EMPTY,
} from "../../../Utils/Constant";

const initialState = {
  data: null,
  loading: false,
  error: null,
  info: null,
};
export const verifyLoginOtpReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case VERFY_LOGIN_OTP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case VERFY_LOGIN_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        info: action.payload,
        error: null,
      };
    case VERFY_LOGIN_OTP_FAILURE:
      return {
        ...state,
        data: {},
        loading: false,
        error: action.payload,
      };
    case VERFY_LOGIN_OTP_EMPTY:
      return {
        ...state,
        data: null,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};
